/**
 * Dynamic User Count Utility
 * 
 * Calculates the current user count based on:
 * - Base count: 2,500 users (starting week)
 * - Growth rate: +200 users per week
 * - Launch date: February 18, 2026
 */

const LAUNCH_DATE = new Date('2026-02-18T00:00:00Z');
const BASE_COUNT = 2500;
const WEEKLY_GROWTH = 200;

/**
 * Calculate the current user count based on weeks since launch
 */
export function getCurrentUserCount(): number {
  const now = new Date();
  const diffTime = now.getTime() - LAUNCH_DATE.getTime();
  const diffWeeks = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 7));
  
  // Ensure we never go below base count (in case of clock issues)
  const weeksElapsed = Math.max(0, diffWeeks);
  
  return BASE_COUNT + (weeksElapsed * WEEKLY_GROWTH);
}

/**
 * Format user count for display (e.g., "2,500+" or "2.5K+")
 */
export function formatUserCount(count?: number, short: boolean = false): string {
  const actualCount = count ?? getCurrentUserCount();
  
  if (short && actualCount >= 1000) {
    const thousands = (actualCount / 1000).toFixed(1);
    return `${thousands}K+`;
  }
  
  return `${actualCount.toLocaleString()}+`;
}
